// extracted by mini-css-extract-plugin
export default {"search":"searchInput_search__c7aC4"};